export default {
  ranking: {

    title: 'DBRank100总榜',
    card: [
      [
        '日总榜',
        '日涨幅',
        '日跌幅',
        '*(行业内)',
        '心智占有率'
      ], [
        '周总榜',
        '周涨幅',
        '周跌幅',
        '*(行业内)',
        '心智占有率'
      ], [
        '月总榜',
        '月涨幅',
        '月跌幅',
        '*(行业内)',
        '心智占有率'
      ]

    ],
    items: [
      [
        '排名',
        '品牌名称',
        '行业',
        'DB总值',
        '日涨跌幅',
        '传播度',
        '参与度',
        '好感度',
        '*(行业内)心智占有率'
      ], [
        '排名',
        '品牌名称',
        '行业',
        'DB总值',
        '周涨跌幅',
        '波峰值',
        '波谷值',
        '*(行业内)心智占有率',
        `*(行业内)</br>心智占有率涨跌`,
        '周排名波动'
      ], [
        '排名',
        '品牌名称',
        '行业',
        'DB总值',
        '月涨跌幅',
        '波峰值',
        '波谷值',
        '*(行业内)心智占有率',
        `*(行业内)</br>心智占有率涨跌`,
        '月排名波动'

      ]
    ]
  },

  geo: {
    title: '地理榜—',
    card: [
      [
        '地理榜',
        '日涨幅',
        '日跌幅',
        '*(归属地)',
        '心智占有率'
      ], [
        '地理榜',
        '周涨幅',
        '周跌幅',
        '*(归属地)',
        '心智占有率'
      ], [
        '地理榜',
        '月涨幅',
        '月跌幅',
        '*(归属地)',
        '心智占有率'
      ]
    ],
    items: [
      [
        '排名',
        '品牌名称',
        '行业',
        'DB总值',
        '日涨跌幅',
        '传播度',
        '参与度',
        '好感度',
        '*(归属地)心智占有率',
        `*(归属地)</br>心智占有率涨跌`,
      ], [
        '排名',
        '品牌名称',
        '行业',
        'DB总值',
        '周涨跌幅',
        '波峰值',
        '波谷值',
        '*(归属地)心智占有率',
        `*(归属地)</br>心智占有率涨跌`,
      ], [
        '排名',
        '品牌名称',
        '行业',
        'DB总值',
        '月涨跌幅',
        '波峰值',
        '波谷值',
        '*(归属地)心智占有率',
        `*(归属地)</br>心智占有率涨跌`,
      ]
    ]

  },

  industry: {
    title: '行业榜—',
    card: [
      [
        '行业榜',
        '日涨幅',
        '日跌幅',
        '*(行业内)',
        '心智占有率'
      ], [
        '行业榜',
        '周涨幅',
        '周跌幅',
        '*(行业内)',
        '心智占有率'
      ], [
        '行业榜',
        '月涨幅',
        '月跌幅',
        '*(行业内)',
        '心智占有率'
      ]
    ],
    items: [
      [
        '排名',
        '品牌名称',
        'DB总值',
        '日涨跌幅',
        '传播度',
        '参与度',
        '好感度',
        '*(行业内)心智占有率',
        `*(行业内)</br>心智占有率涨跌`,
      ], [
        '排名',
        '品牌名称',
        'DB总值',
        '周涨跌幅',
        '波峰值',
        '波谷值',
        '*(行业内)心智占有率',
        `*(行业内)</br>心智占有率涨跌`,

      ], [
        '排名',
        '品牌名称',
        'DB总值',
        '月涨跌幅',
        '波峰值',
        '波谷值',
        '*(行业内)心智占有率',
        `*(行业内)</br>心智占有率涨跌`,

      ]
    ]

  },

  platform: {
    title: '平台榜—',
    card: [
      [
        '平台榜',
        '日涨幅',
        '日跌幅',
        '*(行业内)',
        '心智占有率'
      ], [
        '平台榜',
        '周涨幅',
        '周跌幅',
        '*(行业内)',
        '心智占有率'
      ], [
        '平台榜',
        '月涨幅',
        '月跌幅',
        '*(行业内)',
        '心智占有率'
      ]
    ],
    items: [
      [
        '排名',
        '品牌名称',
        '行业',
        '平台DB值',
        '日涨跌幅',
        '传播度',
        '参与度',
        '好感度',
        '*(行业内)心智占有率',
        `*(行业内)</br>心智占有率涨跌`,
      ], [
        '排名',
        '品牌名称',
        '行业',
        '平台DB值',
        '周涨跌幅',
        '波峰值',
        '波谷值',
        '*(行业内)心智占有率',
        '*(行业内)</br>心智占有率涨跌',
      ], [
        '排名',
        '品牌名称',
        '行业',
        '平台DB值',
        '月涨跌幅',
        '波峰值',
        '波谷值',
        '*(行业内)心智占有率',
        '*(行业内)</br>心智占有率涨跌',
      ]
    ]

  },
  soMe: {
    title: 'So-Me指数排行榜',
    card: [
      [
        '日总榜',
        '日涨幅',
        '日跌幅',
        '*(行业内)',
        '心智占有率'
      ], [
        '周总榜',
        '周涨幅',
        '周跌幅',
        '*(行业内)',
        '心智占有率'
      ], [
        '月总榜',
        '月涨幅',
        '月跌幅',
        '*(行业内)',
        '心智占有率'
      ]

    ],
    items: [
      [
        '排名',
        '品牌名称',
        '行业',
        'DB总值',
        '日涨跌幅',
        '传播度',
        '参与度',
        '好感度',
        '*(行业内)心智占有率'
      ], [
        '排名',
        '品牌名称',
        '行业',
        'DB总值',
        '周涨跌幅',
        '波峰值',
        '波谷值',
        '*(行业内)心智占有率',
        `*(行业内)</br>心智占有率涨跌`,
        '周排名波动'
      ], [
        '排名',
        '品牌名称',
        '行业',
        'DB总值',
        '月涨跌幅',
        '波峰值',
        '波谷值',
        '*(行业内)心智占有率',
        `*(行业内)</br>心智占有率涨跌`,
        '月排名波动'

      ]
    ]
  }
}


// WEBPACK FOOTER //
// src/components/Ranktable/rankingList.js